module.exports = __webpack_public_path__ + "static/media/hangingMassProblem1.369c3573.svg";